<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>商家风格</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="refresh(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>筛选查询</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-col :span="24">
                <el-form
                  :inline="true"
                  :model="filterForm"
                  class="demo-form-inline"
                >
                  <el-form-item label="风格名称:">
                    <el-input
                      v-model="filterForm.name"
                      placeholder="风格名称"
                      @click="search"
                    />
                  </el-form-item>
                  <el-form-item label="状态:">
                    <el-select
                      v-model="filterForm.status"
                      placeholder="状态"
                      @click="search"
                    >
                      <el-option value="">全部</el-option>
                      <el-option
                        v-for="item in statusAttr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="search">查询</el-button>
                  </el-form-item>
                </el-form>
              </el-col>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <el-button
            type="success"
            size="mini"
            style="margin-left: auto"
            @click="output"
            >导出</el-button
          >
          <el-button type="primary" size="mini" @click="addSupplyStyle">
            +创建风格</el-button
          >
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            :cell-class-name="addColor"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="center"
              prop="supply_style_id"
              label="id"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_style"
              label="风格"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_style_status"
              label="状态"
            ></el-table-column>
            <el-table-column fixed="right" label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="updateSupplyStyle(scope.row)">
                  编辑</el-button
                >
                <el-button
                  size="small"
                  :type="scope.row.status == 1 ? 'danger' : 'success'"
                  @click="changeStyle(scope.row)"
                >
                  {{ scope.row.status == 1 ? "设为禁用" : "设为启用" }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-dialog
            title="创建风格"
            :visible.sync="dialogFormVisible"
            width="30%"
            center
          >
            <el-form :model="form">
              <el-form-item label="风格名称">
                <el-input v-model="form.supply_style"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="editStyle">确 定</el-button>
            </div>
          </el-dialog>
        </div>

        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.pages"
            :page-size="10"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      filterForm: {
        name: "",
        status: "",
        page: 1,
        is_excel: 0,
      },
      logVisible: false,
      resData: {
        pg_list: [],
        reson_2: [],
        child_market: [],
      },
      supply: {
        list: [],
      },
      form: {
        supply_style_id: 0,
        supply_style: "",
      },
      statusAttr: [
        {
          label: "正常",
          value: "1",
        },
        {
          label: "禁止",
          value: "2",
        },
      ],
      loading: false,
      tableLoading: false,
      url: "/erp/Supply/supplyStyles",
      curPage: 1,
      filterFold: false,
      isAll: false,
      supplyData: null,
      dialogFormVisible: false,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.filterForm) {
        if (
          this.filterForm[key] === undefined ||
          this.filterForm[key] === "" ||
          this.filterForm[key] === null
        ) {
          delete this.filterForm[key];
        }
      }
      return this.filterForm;
    },
  },
  methods: {
    addColor({ row, column, columnIndex }) {
      // if (columnIndex === 15) {
      //     return 'blue-cell';
      // }
    },

    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        this.tableLoading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else if (this.filterForm.is_excel) {
          window.open(apiBaseURL + res.data.data.file);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      for (const key in val) {
        multipleSelection[key] = {
          id: val[key].id,
        };
      }
      this.form.multipleSelection = JSON.stringify(multipleSelection);
    },
    // 切换页码
    handleCurrentChange(val) {
      this.filterForm.page = val;
      this.filterForm.is_excel = 0;
      this.tableLoading = true;
      this.fetchData(true);
    },
    search() {
      this.filterForm.page = 1;
      this.filterForm.is_excel = 0;
      this.tableLoading = true;
      this.fetchData(true);
    },
    refresh() {
      this.filterForm.is_excel = 0;
      this.tableLoading = true;
      this.fetchData(true);
    },
    trim(str, is_global) {
      let result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (is_global.toLowerCase() == "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
    editStyle() {
      this.$http.post("/erp/supply/editStyle", this.form).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.dialogFormVisible = false;
          this.$message.success(res.data.msg);
          this.refresh();
        }
      });
    },
    changeStyle(scope) {
      this.$http
        .post(
          `/erp/supply/changeStyle/supply_style_id/${scope.supply_style_id}`
        )
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.$message.success(res.data.msg);
            this.refresh();
          }
        });
    },
    addSupplyStyle() {
      this.$set(this.form, "supply_style_id", 0);
      this.$set(this.form, "supply_style", "");
      this.dialogFormVisible = true;
    },
    updateSupplyStyle(row) {
      this.$set(this.form, "supply_style_id", row.supply_style_id);
      this.$set(this.form, "supply_style", row.supply_style);
      this.dialogFormVisible = true;
    },
    output() {
      this.filterForm.is_excel = 1;
      this.fetchData(true);
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/supply/SupplyStyles.vue